import { useContext } from 'react';

import { AdminNavigationContext } from './AdminNavigationContext';

export const useAdminNavigation = () => {
  const context = useContext(AdminNavigationContext);

  if (!context) {
    throw new Error('useAdminNavigation must be used within AdminNavigationProvider');
  }

  return context;
};
